import { render } from "./shairedFolder.vue?vue&type=template&id=48714efe&scoped=true"
import script from "./shairedFolder.js?vue&type=script&lang=js"
export * from "./shairedFolder.js?vue&type=script&lang=js"

import "./shairedFolder.vue?vue&type=style&index=0&id=48714efe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48714efe"]])

export default __exports__